import { defineMessages } from 'react-intl';

const translations = {
  actions: {
    authorize: {
      id: 'actions.authorize',
      defaultMessage: 'Authorize',
      description: 'Label of the authorize calculation button',
    },
  },
  confirmAuthorizeCalculation: {
    title: {
      id: 'pages.calculationsSection.confirmAuthorizeCalculation.title',
      defaultMessage: 'Authorize calculation',
      description: 'Title of the confirm authorize calculation dialog',
    },
    description: {
      id: 'pages.calculationsSection.confirmAuthorizeCalculation.description',
      defaultMessage:
        'Are you sure you would like to authorize this calculation? You can`t authorize another calculation afterwards',
      description: 'Description of the confirm authorize calculation dialog',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'Label of the cancel button of the confirm authorize calculation dialog',
      },
      authorize: {
        id: 'actions.authorize',
        defaultMessage: 'Authorize',
        description: 'Label of the authorize button of the confirm authorize calculation dialog',
      },
    },
  },
  feedback: {
    calculationAuthorized: {
      id: 'pages.calculationsSection.feedback.calculationAuthorized',
      defaultMessage: 'Calculation authorized',
      description: 'Success message of the authorize calculation',
    },
    calculationNotAuthorized: {
      id: 'pages.calculationsSection.feedback.calculationNotAuthorized',
      defaultMessage: 'Calculation not authorized',
      description: 'Error message of the authorize calculation',
    },
    calculationNoCreditAvailable: {
      id: 'pages.calculationsSection.feedback.calculationNoCreditAvailable',
      defaultMessage: 'No credit available to authorize the calculation',
      description: 'Error message of the authorize calculation when no credit is available',
    },
    calculationNotPaid: {
      id: 'pages.calculationsSection.feedback.calculationNotPaid',
      defaultMessage: 'Calculation needs to be paid before authorizing the calculation',
      description:
        'Error message of the authorize calculation when the calculation needs to be paid',
    },
  },
};

export default defineMessages(translations);
